<script>
  import { onMount } from 'svelte';

  import { activeCountry, mapTransform } from '../stores';

  export let data;
  export let projection;
  export let tooltipIsoCode;

  let isInitial = true;

  onMount(() => {
    window.setTimeout(() => {
      isInitial = false;
    }, 700);
  });

  $: germanyCenter = projection([13, 52.5]);

  $: getArcPath = params => {
    // https://observablehq.com/@d3/mobile-patent-suits
    const dx = germanyCenter[0] - params.cx;
    const dy = germanyCenter[1] - params.cy;
    const dr = Math.hypot(
      germanyCenter[0] - params.cx,
      germanyCenter[1] - params.cy
    );

    const clockwise = params.cx < germanyCenter[0] ? 1 : 0;

    return `M ${params.cx},${params.cy}A${dr},${dr} 0 0,${clockwise} ${germanyCenter[0]},${germanyCenter[1]}`;
  };

  $: arcCenters =
    tooltipIsoCode || $activeCountry
      ? data.filter(
          d => (d.id === tooltipIsoCode || d.id === $activeCountry) && d.r
        )
      : [];
</script>

<style>
  .km-arc {
    fill: none;
    stroke-dasharray: 4px;
    stroke-dashoffset: 8px;
    animation: stroke 800ms linear infinite;
    pointer-events: none;
    will-change: stroke-dashoffset;
    transition: fill-opacity 300ms;
  }

  .km-arc.inactive {
    animation: none;
  }

  .km-arccenter {
    pointer-events: none;
  }

  @keyframes stroke {
    to {
      stroke-dashoffset: 0;
    }
  }
</style>

<g transform={$mapTransform}>
  {#each data as arcParams}
    {#if arcParams.isVisible && !($activeCountry && arcParams.id !== $activeCountry)}
      <path
        class="km-arc"
        class:inactive={$activeCountry && arcParams.id !== $activeCountry}
        d={getArcPath(arcParams)}
        stroke-opacity={isInitial ? 0 : arcParams.id === $activeCountry || arcParams.isHovered ? 1 : 0.4}
        stroke={arcParams.stroke} />
    {/if}
  {/each}
</g>

{#if arcCenters && arcCenters.length > 0}
  <g transform={$mapTransform}>
    {#each arcCenters as arcCenter}
      <circle
        cx={arcCenter.cx}
        cy={arcCenter.cy}
        fill={arcCenter.fill}
        r={2}
        class="km-arccenter" />
    {/each}

    <circle
      cx={germanyCenter[0]}
      cy={germanyCenter[1]}
      fill={arcCenters[0].fill}
      r={2}
      class="km-arccenter" />
  </g>
{/if}
